import {
  ChatConversacion,
  ChatMensaje,
  ChatMensajeTipo,
  SolicitudPendiente,
} from '../interfaces/chat.interface';
import { SolicitudNotaDto, SolicitudUserDto } from '../interfaces/solicitud-user.interface';

const TIPOS_MENSAJE = new Set<ChatMensajeTipo>(['admin', 'solicitud', 'sistema']);

export function mapNotaTipo(tipo?: string): ChatMensajeTipo {
  if (tipo === 'usuario') {
    return 'solicitud';
  }
  if (tipo && TIPOS_MENSAJE.has(tipo as ChatMensajeTipo)) {
    return tipo as ChatMensajeTipo;
  }
  return 'sistema';
}

function mapMensajes(user: SolicitudUserDto): ChatMensaje[] {
  return (user.descripcion ?? []).map((nota: SolicitudNotaDto, index) => ({
    id: `${user.id}-${index}`,
    nota: nota.nota ?? '',
    hora: nota.hora ?? '',
    fecha: nota.fecha ?? '',
    autor: nota.autor ?? '',
    tipo: mapNotaTipo(nota.tipo),
    leido: !!nota.leido,
  }));
}

function mapSolicitudes(user: SolicitudUserDto): SolicitudPendiente[] {
  const solicitudes: SolicitudPendiente[] = [];
  if (user.soliEliminar) {
    solicitudes.push({ tipo: 'eliminar', motivo: user.motivoEliminar ?? '' });
  }
  if (user.soliEstudio) {
    solicitudes.push({ tipo: 'estudio', motivo: user.descEstudio ?? '' });
  }
  if (user.soliBautismo) {
    solicitudes.push({ tipo: 'bautismo', motivo: user.motivoBautismo ?? '' });
  }
  if (user.soliEliminarBautismo) {
    solicitudes.push({ tipo: 'bajaBautismo', motivo: user.motivoEliminarBautismo ?? '' });
  }
  if (user.soliNivel) {
    solicitudes.push({ tipo: 'nivel', motivo: user.motivoNivel ?? '' });
  }
  return solicitudes;
}

export function mapUserToChat(user: SolicitudUserDto): ChatConversacion {
  const img = user.img?.trim() ? user.img : null;

  return {
    personaId: user.id,
    nombre: user.nombre ?? '',
    apellido: user.apellido ?? '',
    img,
    sexo: user.sexo ?? '',
    miLider: user.miLider ?? '',
    idLider: user.idLider ?? '',
    nivelPersonal: user.nivelPersonal ?? 0,
    nacimiento: user.nacimiento ?? null,
    ultimaActualizacion: user.ultimaActualizacion ?? new Date(0).toISOString(),
    mensajes: mapMensajes(user),
    solicitudes: mapSolicitudes(user),
    bautizado: !!user.bautizado,
    inscBautismo: !!user.inscBautismo,
    reunionSelect: user.reunionSelect,
  };
}
